import script from "./insureCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./insureCompany.vue?vue&type=script&setup=true&lang=js"

import "./insureCompany.vue?vue&type=style&index=0&id=e8a0f896&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8a0f896"]])

export default __exports__